import { render, staticRenderFns } from "./EditExpert.vue?vue&type=template&id=1b355cce"
import script from "./EditExpert.vue?vue&type=script&lang=js"
export * from "./EditExpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports